<template>
  <div class="hfoot">
    <p>Copyright <font class="fontfam">&copy;</font> 2024
      www.cdelvip.com All Rights Reserved.
      <span class="useCopyright">北京正保财智教育科技有限公司 版权所有</span>
    </p>
    <p>
      <!-- <a href="javascript:void(0);" rel="external nofollow">京ICP备2024067159号</a> -->
      <a href="//beian.miit.gov.cn/" target="_blank" rel="external nofollow">京ICP备2024067159号-1</a>
      <a target="_blank" href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802044406">
        <img src="//www.chinaacc.com/images/ba-icon.png"  border="0" style="display:inline-block;vertical-align:middle;margin:-3px 3px 0 0"  width="20" height="20"/>京公网安备11010802044406号
      </a>
    </p>
  </div>
</template>
<script>
export default {
  name: 'PublicFooter',
  global: true
};
</script>
<style scoped lang='scss'>
.hfoot{padding:22px 0; color:#666; font-size:12px; font-family:\5FAE\8F6F\96C5\9ED1,\9ED1\4F53; text-align:center; line-height:26px; background: #f6f6f6; border-top: 1px solid #eee;}
/*.hfoot p{margin:0;}*/
.hfoot a{ color:#666; text-decoration:none;}
.hfoot .fontfam{ font-family:Verdana,Arial,Helvetica,sans-serif;}
.hfoot a:hover{ color:#0070c3;}
.hfoot-list{ height:48px; padding-top:4px}
.hfoot-list a{ margin:0 5px;}
</style>
